import { render, staticRenderFns } from "./product-support.vue?vue&type=template&id=4ad134ca&scoped=true&"
import script from "./product-support.vue?vue&type=script&lang=js&"
export * from "./product-support.vue?vue&type=script&lang=js&"
import style0 from "./product-support.vue?vue&type=style&index=0&id=4ad134ca&lang=scss&scoped=true&"
import style1 from "./product-support.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad134ca",
  null
  
)

export default component.exports